/* istanbul ignore file */
import { useDecodedToken, useRefreshAccessToken } from 'mf_core/auth';
import React, { useEffect, useState } from 'react';
import { useMyBusinessMenu } from '../hooks/use-mybusinessmenu';
import { useProductMenuQuery } from '../hooks/use-product';
import { useLocalizationContext } from '@im/react-localization';
import { useVendorsMenuQuery } from '../hooks/use-vendorsmenu';
import { useSolutionsMenuQuery } from '../hooks/use-solutionsmenu';
import { useServicesMenuQuery } from '../hooks/use-servicesmenu';
import { useFeatureFlagBase } from '../hooks/use-feature-flag-base';

export function InvalidAccessToken() {
  const decodedToken = useDecodedToken();
  const refreshAccessToken = useRefreshAccessToken();
  const [count, setCount] = useState(0);
  const [badToken, setBadToken] = useState(false);
  const { locale } = useLocalizationContext();
  const { refetch: refetchBaseBackofficeKeys } = useFeatureFlagBase();
  const { refetch: refetchMyBusinessMenuItems } = useMyBusinessMenu();
  const { refetch: refetchProductsMenuItems } = useProductMenuQuery(
    locale,
    true
  );
  const { refetch: refetchVendorsMenuItems } = useVendorsMenuQuery(
    locale,
    true
  );
  const { refetch: refetchSolutionsMenuItems } = useSolutionsMenuQuery(
    locale,
    true
  );

  const { refetch: refetchServicesMenuItems } = useServicesMenuQuery(
    locale,
    true
  );

  useEffect(() => {
    if (decodedToken) {
      if (!decodedToken.imoProfile) {
        setBadToken(true);
        if (count === 5) {
          throw new Error('[Okta inline hook error] Access token is invalid!');
        }
        setTimeout(async () => {
          await refreshAccessToken();
          setCount(count + 1);
        }, 5000);
      } else {
        setCount(0);
        if (badToken) {
          setBadToken(false);
          refetchBaseBackofficeKeys();
          refetchMyBusinessMenuItems();
          refetchProductsMenuItems();
          refetchVendorsMenuItems();
          refetchSolutionsMenuItems();
          refetchServicesMenuItems();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decodedToken]);

  return <></>;
}
